import { render, staticRenderFns } from "./orderCustomDetail.vue?vue&type=template&id=87551e22"
import script from "./orderCustomDetail.vue?vue&type=script&lang=js"
export * from "./orderCustomDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports